import React from "react";
import CarService from "../../services/CarService";
import CalculatorSelectForm from "../../components/calculator/selectForm/CalculatorSelectForm";
import CalculatorContent from "../../components/calculator/content/CalculatorContent";
import {baseUrl, mode} from "../../utils/Config";
import CalculatorDescription from "../../components/calculator/description/CalculatorDescription";
import ErrorPopUp from "../../components/base/popUp/errorPopUp/ErrorPopUp";
import PopUp from "../../components/base/popUp/PopUp";

interface ICalculatorPageContainerState {
  image?: File
  models?: Array<{
    name: string
    image: string
  }>
  motors?: Array<string>
  transmissions?: Array<string>
  drives?: Array<string>
  pms?: Array<string>
  pmData?: App.IObject
  selected: {
    model?: string
    motor?: string
    transmission?: string
    drive?: string
    pm?: string
  }
  tab: number
  writeForPMData: {
    surname: string
    name: string
    patronymic: string
    car_number: string
    phone: string
  }
  popUp?: JSX.Element
  busy: boolean
}

export default class CalculatorPageContainer extends React.Component<any, ICalculatorPageContainerState> {
  private carService: CarService;
  // @ts-ignore
  static noCarImageUrl: string = `${mode === 'prod' ? `${baseUrl}/calculator/api` : `http://localhost/calculator/api`}/storage/icons/no-car.png`;
  constructor(props: any) {
    super(props);

    this.carService = new CarService();

    this.state = {
      selected: {},
      tab: 2,
      writeForPMData: {
        surname: '',
        name: '',
        patronymic: '',
        car_number: '',
        phone: '',
      },
      busy: false
    };
  }

  componentDidMount(): void {
    this.carService.models().then((result) => {
      if (result && result.status === 200) {
        this.setState({
          models: result.response
        })
      }
    });
    fetch(CalculatorPageContainer.noCarImageUrl).then(async (result) => {
      let blob = await result.blob();
      this.setState({
        image: new File([blob], "image")
      })
    });
  }

  async setMotors(model: string) {
    let result = await this.carService.motors(model);
    if (result && result.status === 200) {
      let motors = result.response;

      this.setState({
        motors: motors,
        selected: {
          model: model,
          motor: undefined,
          transmission: undefined,
          drive: undefined,
          pm: undefined
        }
      });

      if (motors.length === 1) {
        setTimeout(() => this.setTransmissions(model, motors[0]))
      }
    }
  }

  async setTransmissions(model: string, motor: string) {
    let result = await this.carService.transmissions(model, motor);
    if (result && result.status === 200) {
      let transmissions = result.response;

      this.setState({
        transmissions: transmissions,
        selected: {
          model: model,
          motor: motor,
          transmission: undefined,
          drive: undefined,
          pm: undefined
        }
      });

      if (transmissions.length === 1) {
        setTimeout(() => this.setDrives(model, motor, transmissions[0]))
      }
    }
  }

  async setDrives(model: string, motor: string, transmission: string) {
    let result = await this.carService.drives(model, motor, transmission);
    if (result && result.status === 200) {
      let drives = result.response;

      this.setState({
        drives: drives,
        selected: {
          model: model,
          motor: motor,
          transmission: transmission,
          drive: undefined,
          pm: undefined
        }
      });

      if (drives.length === 1) {
        setTimeout(() => this.setPMs(model, motor, transmission, drives[0]))
      }
    }
  }

  async setPMs(model: string, motor: string, transmission: string, drive: string) {
    let result = await this.carService.pms(model, motor, transmission, drive);
    if (result && result.status === 200) {
      this.setState({
        pms: result.response,
        selected: {
          model: model,
          motor: motor,
          transmission: transmission,
          drive: drive,
          pm: undefined
        }
      });
    }
  }

  async setPMData(model: string, motor: string, transmission: string, drive: string, pm: string) {
    let result = await this.carService.pm(model, motor, transmission, drive, pm);

    if (result && result.status === 200) {
      this.setState({
        pmData: result.response,
        selected: {
          model: model,
          motor: motor,
          transmission: transmission,
          drive: drive,
          pm: pm
        }
      });
    }
  }

  async select(key: string, value: string) {
    if (key === 'model') {
      let url = this.state.models?.find(element => element.name === value)?.image;

      if (url)
        fetch(url).then(async (result) => {
          let blob = await result.blob();
          this.setState({
            image: new File([blob], "image")
          })
        });
      await this.setMotors(value);
    } else if (key === 'motor') {
      await this.setTransmissions(this.state.selected.model || '', value);
    } else if (key === 'transmission') {
      await this.setDrives(this.state.selected.model || '',
        this.state.selected.motor || '', value);
    } else if (key === 'drive') {
      await this.setPMs(this.state.selected.model || '',
        this.state.selected.motor || '',
        this.state.selected.transmission || '', value);
    } else if (key === 'pm') {
      await this.setPMData(this.state.selected.model || '',
        this.state.selected.motor || '',
        this.state.selected.transmission || '',
        this.state.selected.drive || '', value);
    }
  }

  changeTab(tab: number) {
    this.setState({
      tab: tab
    });
  }

  onInputChange(name: string, value: any) {
    this.setState({
      writeForPMData: {
        ...this.state.writeForPMData,
        [name]: value
      }
    })
  }

  writeForPM() {
    if (this.state.busy)
      return

    let data = {
      ...this.state.selected,
      ...this.state.writeForPMData,
      type: 'to'
    };

    this.carService.writeForPM(data).then(result => {
      if (result && result.status === 200) {
        let message = JSON.parse(result.response).message;
        this.setState({
          popUp: <ErrorPopUp errors={message} />,
          busy: false
        })
      } else
        this.setState({
          busy: false
        })
    });

    // this.setState({
    //   popUp: <ErrorPopUp errors={['В разработке.']} />
    // })

  }

  closePopUp() {
    this.setState({
      popUp: undefined
    })
  }

  render() {
    let models: Array<string> = [];
    this.state.models?.forEach(model => {
      models.push(model.name);
    });
    return <div className='calculator-page-container'>
      {
        this.state.selected.model &&
          this.state.selected.motor &&
          this.state.selected.transmission &&
          this.state.selected.drive &&
          this.state.selected.pm &&
          this.state.pmData ?
            <CalculatorContent
              model={this.state.selected.model}
              motor={this.state.selected.motor}
              transmission={this.state.selected.transmission}
              drive={this.state.selected.drive}
              pm={this.state.selected.pm}
              pmData={this.state.pmData}
              tab={this.state.tab}
              changeTab={this.changeTab.bind(this)}
            />
              :
            <CalculatorDescription/>
      }
      <CalculatorSelectForm
        {...this.state}
        models={models}
        select={this.select.bind(this)}
        onInputChange={this.onInputChange.bind(this)}
        onPMWrite={this.writeForPM.bind(this)}
      />
      {
        this.state.popUp ?
          <PopUp
            children={this.state.popUp}
            callback={this.closePopUp.bind(this)}
          />
          :
          <></>
      }
    </div>
  }
}